import { API_ENDPOINTS } from '@/config/api.endpoints'

export class FCCUrlBuilder {
  private baseUrl: string

  constructor() {
    this.baseUrl = API_ENDPOINTS.FCC.BASE_URL
  }

  /**
   * Build merchant details URL
   */
  merchantDetails(merchantId: string | number): string {
    return `${API_ENDPOINTS.FCC.MERCHANTS}/${merchantId}/details`
  }

  /**
   * Build merchant event tolerances URL
   */
  merchantEventTolerances(merchantId: string | number): string {
    return `${API_ENDPOINTS.FCC.MERCHANTS}/${merchantId}/event-tolerances`
  }

  /**
   * Build merchant alert history URL
   */
  merchantAlertHistory(merchantId: string | number): string {
    return `${API_ENDPOINTS.FCC.MERCHANTS}/${merchantId}/alerts/history`
  }

  /**
   * Build update merchant tolerance URL
   */
  updateMerchantTolerance(merchantId: string | number): string {
    return `${API_ENDPOINTS.FCC.MERCHANTS}/${merchantId}`
  }

  /**
   * Build update merchant event tolerance URL
   */
  updateMerchantEventTolerance(merchantId: string | number): string {
    return `${API_ENDPOINTS.FCC.MERCHANTS}/${merchantId}/event-tolerance`
  }

  /**
   * Build alert actions URL
   */
  alertActions(alertId: string | number): string {
    return `${API_ENDPOINTS.FCC.ALERTS}/${alertId}/actions`
  }

  /**
   * Build case details URL
   */
  caseDetails(caseId: string | number): string {
    return `${API_ENDPOINTS.FCC.CASES}/${caseId}`
  }

  /**
   * Build close case URL
   */
  caseClose(caseId: string | number): string {
    return `${API_ENDPOINTS.FCC.CASES}/${caseId}/close`
  }

  /**
   * Build JIRA issue URL
   */
  jiraIssue(issueId: string | number): string {
    return `${API_ENDPOINTS.FCC.JIRA_ISSUES}/${issueId}`
  }

  /**
   * Build JIRA issue comments URL
   */
  jiraIssueComments(issueId: string | number): string {
    return `${API_ENDPOINTS.FCC.JIRA_ISSUES}/${issueId}/comments`
  }

  /**
   * Build update merchant max amount URL
   */
  updateMerchantMaxAmount(merchantId: string | number): string {
    return `${API_ENDPOINTS.FCC.MERCHANTS}/${merchantId}/reserve/max-amount`
  }

  /**
   * Build enable reserve URL
   */
  enableReserve(merchantId: string | number): string {
    return `${API_ENDPOINTS.FCC.MERCHANTS}/${merchantId}/reserve/enable`
  }

  /**
   * Build merchant reserve metrics URL
   */
  merchantReserveMetrics(merchantId: string | number): string {
    return `${API_ENDPOINTS.FCC.MERCHANTS}/${merchantId}/reserve/metrics`
  }

  /**
   * Build set reserve (via Persona) URL
   */
  setReservePersona(merchantId: string | number): string {
    return `${API_ENDPOINTS.FCC.MERCHANTS}/${merchantId}/reserve/persona`
  }

  /**
   * Build set reserve (manual) URL
   */
  setReserveManual(merchantId: string | number): string {
    return `${API_ENDPOINTS.FCC.MERCHANTS}/${merchantId}/reserve/manual`
  }

  /**
   * Build update reserve percent holdback URL
   */
  updatePercentHoldback(merchantId: string | number): string {
    return `${API_ENDPOINTS.FCC.MERCHANTS}/${merchantId}/reserve/percent`
  }

  /**
   * Build a custom URL with path segments
   */
  buildUrl(basePath: string, ...segments: (string | number)[]): string {
    return `${basePath}/${segments.join('/')}`
  }

  /**
   * Get base URL for FCC API
   */
  getBaseUrl(): string {
    return this.baseUrl
  }
}

// Export a singleton instance
export const fccUrlBuilder = new FCCUrlBuilder()
